import { call, put, takeEvery, select } from "redux-saga/effects";
import { callApiWithNoAuth, Method } from "../../api/Api";
import { RouteService, resolveCustomerName } from "services/route.service";
import {
  stopLoading,
  showErrorMessage,
  startLoading,
} from "../layout/action";
import {
  GET_VISITOR_PERMITLIST,
  setVisitorPermitListAction,
  CREATE_VISITOR_PERMIT,
  GET_PDF_VISITOR_PERMIT,
  GET_CARD_TYPE_VISITOR_PERMIT,
  setCardTypeVisitorPermit,
  setVisitorPermit,
  openVisitorPermitOrderSuccessModal,
} from "./action";

export function* callGetVisitorPermitList(action) {
  try {
    const { loginState } = yield select();
    const { userContext } = loginState;
    yield put(startLoading());
    const stateResponse = yield call(callApiWithNoAuth, {
      method: "GET",
      url: `/portal/pages/home-without-session/visitor/${action.payload}`,
    });

    const { data } = stateResponse;
    yield put(setVisitorPermitListAction(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get visitor Permit list" })
    );
  }
}

export function* watchGetcallGetVisitorPermitList() {
  yield takeEvery(GET_VISITOR_PERMITLIST, callGetVisitorPermitList);
}

export function* callCreateVisitorPermit(action) {
  try {
    yield put(startLoading());
    const store = yield select();
    const customerName = resolveCustomerName(
      store.homeState?.customerName,
      window.location.pathname
    );
    if (!customerName) {
      yield put(
        showErrorMessage({
          error: { data: { errorMessages: "Missing customer/realm context. Please reload the page." } },
          title: "Visitor Permit Submited",
        })
      );
      return;
    }
    const dataPayload = action?.payload;
    const paymentMethod = dataPayload.ocr?.paymentRequest?.paymentMethod?.value;
    const isTransactPayments = paymentMethod === "TRANSACT_PAYMENTS";

    if (isTransactPayments) {
      delete dataPayload.ocr.paymentRequest;
    }

    const createResponse = yield call(callApiWithNoAuth, {
      data: dataPayload,
      method: Method.POST,
      url: `/portal/pages/home-without-session/visitor/create`,
    });

    if (isTransactPayments) {
      const { order, redirectDetails } = createResponse.data;
      const { url, parameters } = redirectDetails;
      const confirmationUrl = RouteService.visitorPermitForm(customerName);

      // Add signOutUrls parameter
      const fullParameters = {
        ...parameters,
        signOutUrl: `${process.env.REACT_APP_PORTAL_HOST}${confirmationUrl}`,
        incompleteSignOutUrl: `${process.env.REACT_APP_PORTAL_HOST}${RouteService.incompletePayment(customerName)}`,
      };

      // Add notification url
      if (fullParameters.alt_otpsso_url) {
        fullParameters.alt_otpsso_url = `${process.env.REACT_APP_PROXY_HOST}${fullParameters.alt_otpsso_url}`;
      }

      // Build query string
      const searchParams = new URLSearchParams();
      Object.keys(fullParameters).forEach(key => {
        searchParams.append(key, fullParameters[key]);
      });

      yield put(setVisitorPermit(order));

      // Redirect to the external link
      window.location.href = `${url}?${searchParams.toString()}`;
    } else {
      const order = createResponse.data;
      yield put(setVisitorPermit(order));

      // Open PDF
      const pdfResponse = yield call(callApiWithNoAuth, {
        responseType: "arraybuffer",
        method: "GET",
        url: `/portal/pages/home-without-session/download-efp/${order?.lines[0]?.id}`,
      });

      const file = new Blob([pdfResponse.data], { type: "application/pdf" });
      const url = URL.createObjectURL(file);
      window.open(url);
      // End Open PDF

      yield put(openVisitorPermitOrderSuccessModal());
    }
  } catch (err) {
    yield put(
      showErrorMessage({ error: err, title: "Visitor Permit Submited" })
    );
  } finally {
    yield put(stopLoading());
  }
}

export function* watchVisitorPermit() {
  yield takeEvery(CREATE_VISITOR_PERMIT, callCreateVisitorPermit);
}

export function* callGetPdfVisitorPermit(action) {
  try {
    yield put(startLoading());
    const orderLineId = action?.payload;

    // Open PDF
    const pdfResponse = yield call(callApiWithNoAuth, {
      responseType: 'arraybuffer',
      method: 'GET',
      url: `/portal/pages/home-without-session/download-efp/${orderLineId}`,
    });

    const file = new Blob([pdfResponse.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(file);
    window.open(url);
    // End Open PDF
  } catch (err) {
    yield put(
      showErrorMessage({ error: err, title: "Get ODF Visitor Permit" })
    );
  } finally {
    yield put(stopLoading());
  }
}

export function* watchGetPdfVisitorPermit() {
  yield takeEvery(GET_PDF_VISITOR_PERMIT, callGetPdfVisitorPermit);
}

//#################### CARD TYPE ##################################

export function* callGetVisitorPermitCardType(action) {
  try {
    // const { loginState } = yield select();
    // const { userContext } = loginState;

    yield put(startLoading());
    const cardType = yield call(callApiWithNoAuth, {
      method: "GET",
      // url: `/visitor/client/${action?.payload}`,
      url: `/portal/pages/home-without-session/visitor/client/${action?.payload}`,
    });

    const { data } = cardType;
    yield put(setCardTypeVisitorPermit(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get visitor Permit Card Type" })
    );
  }
}

export function* watchGetGetVisitorPermitCardType() {
  yield takeEvery(GET_CARD_TYPE_VISITOR_PERMIT, callGetVisitorPermitCardType);
}

//#################### CARD TYPE ##################################
